import { useDispatch, useSelector } from 'react-redux'
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import style from './Burger.module.scss'
import { setBurger } from '../../../redux/headerSlices/HeaderSlices';
import { selectHeader } from '../../../redux/headerSlices/HeaderSelector'
import { red } from '@mui/material/colors';

let Burger = () => {

    const dispatch = useDispatch()

    const { burger } = useSelector(selectHeader)

    return (
        <div className={style.profile__burger}>
            <span className={style.burger} onClick={e => dispatch(setBurger(!burger))}>
                {burger ? <MenuOpenIcon sx={{ fontSize: 40, color: red[700] }} /> : <MenuIcon sx={{ fontSize: 40 }} />}
            </span>
        </div>
    )
}

export default Burger